import { useTranslation } from 'react-i18next';
import BottomNav from "../components/BottomNav";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { restitutionApi } from "../services/api";
import Logo from "../components/Logo";
import Button from "../components/Button";
import Input from "../components/Input";
import Callout from "../components/Callout";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A" };

export default function SubmitProof() {
  const { t } = useTranslation();
  const { matchingId } = useParams();
  const navigate = useNavigate();
  const [proofDescription, setProofDesc]   = useState("");
  const [proofSerialNumber, setSerial]     = useState("");
  const [photoCount, setPhotoCount]        = useState(0);
  const [loading, setLoading]              = useState(false);
  const [devis, setDevis]                  = useState(null);

  const submit = async () => {
    if (!proofDescription && !proofSerialNumber && photoCount === 0) {
      toast.error(t("proof.min_required_error")); return;
    }
    setLoading(true);
    try {
      const photos = Array.from({length: photoCount}, (_,i) => `proof_photo_${i+1}.jpg`);
      const res = await restitutionApi.submitProof(matchingId, {
        proofDescription, proofSerialNumber,
        proofPhotoUrls: photos,
      });
      setDevis(res.data.data);
      toast.success(t("proof.validated_toast"));
    } catch (err) {
      toast.error(err.response?.data?.message || t("proof.insufficient_error"));
    } finally { setLoading(false); }
  };

  if (devis) {
    return (
      <div style={{ minHeight:"100vh", background:"#F7F9FC",
        fontFamily:"'DM Sans',sans-serif", padding:"32px" }}>
        <div style={{ maxWidth:"560px", margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"24px" }}>
            <div style={{ fontSize:"48px", marginBottom:"8px" }}>📋</div>
            <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"24px",
              fontWeight:700, color:T.night }}>{t("proof.devis_title")}</h2>
            <p style={{ color:"#64748B", fontSize:"13px", marginTop:"6px" }}>
              {t("proof.devis_subtitle")}</p>
          </div>

          <div style={{ background:"#fff", borderRadius:"16px",
            border:"1.5px solid #E2E8F0", padding:"20px", marginBottom:"20px" }}>
            <p style={{ fontSize:"11px", fontWeight:700, color:"#94A3B8",
              textTransform:"uppercase", letterSpacing:"1px", marginBottom:"16px" }}>
              {t("proof.devis_breakdown")}</p>
            {[
              [t("proof.devis_micropayment"), devis.microPaymentAmount, T.royal],
              [t("proof.devis_prime_min"), devis.primeAmount, T.gold],
              [t("proof.devis_logistics"), devis.logisticsAmount || 0, "#64748B"],
            ].map(([label, amount, color]) => (
              <div key={label} style={{ display:"flex", justifyContent:"space-between",
                padding:"10px 0", borderBottom:"1px solid #F1F5F9", fontSize:"13px" }}>
                <span style={{ color:"#64748B" }}>{label}</span>
                <span style={{ fontWeight:700, color }}>{Number(amount).toLocaleString()} FCFA</span>
              </div>
            ))}
            <div style={{ display:"flex", justifyContent:"space-between",
              padding:"14px 0 0", fontSize:"16px" }}>
              <span style={{ fontWeight:700, color:"#1E293B" }}>{t("proof.devis_total")}</span>
              <span style={{ fontWeight:800, color:T.gold, fontSize:"18px" }}>
                {Number(devis.totalAmount).toLocaleString()} FCFA</span>
            </div>
          </div>

          <div style={{ background:T.goldL, borderRadius:"12px", padding:"14px 16px",
            marginBottom:"20px", fontSize:"13px", color:"#64748B" }}>
            {t("proof.devis_note")}
          </div>

          <Button variant="gold" full
            onClick={() => navigate(`/payer-restitution/${matchingId}`,
              { state: { devis } })}>
            {t("proof.devis_confirm")}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", background:"#F7F9FC", fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(160deg,${T.night},${T.royal})`, padding:"16px 32px 28px" }}>
        <div style={{ maxWidth:"680px", margin:"0 auto" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"12px", marginBottom:"16px" }}>
            <button onClick={() => navigate(-1)}
              style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:"10px",
                width:"36px", height:"36px", color:"#fff", cursor:"pointer", fontSize:"16px" }}>←</button>
            <Logo size="sm" white />
          </div>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:"22px",
            color:"#fff", fontWeight:700 }}>{t("proof.header_title")}</div>
          <div style={{ color:"rgba(255,255,255,0.6)", fontSize:"13px", marginTop:"6px" }}>
            {t("proof.step_label")}</div>
        </div>
      </div>

      <div style={{ maxWidth:"680px", margin:"0 auto", padding:"24px 32px" }}>
        <Callout variant="cyan" icon="🔍">
          {t("proof.callout")}
        </Callout>

        {/* Photos de preuve */}
        <div style={{ marginBottom:"16px" }}>
          <label style={{ display:"block", fontSize:"13px", fontWeight:600,
            color:"#334155", marginBottom:"8px" }}>
            {t("proof.photos_label")} <span style={{color:"#94A3B8", fontWeight:400}}>{t("proof.photos_note")}</span>
          </label>
          <div style={{ display:"flex", gap:"10px" }}>
            {[1,2,3].map(i => (
              <div key={i} onClick={() => setPhotoCount(Math.max(photoCount, i))}
                style={{ width:"80px", height:"80px",
                  border:`2px dashed ${i<=photoCount ? T.cyan : "#E2E8F0"}`,
                  borderRadius:"12px", background: i<=photoCount ? "#E0F7FA" : "#F8FAFC",
                  display:"flex", flexDirection:"column", alignItems:"center",
                  justifyContent:"center", cursor:"pointer", gap:"4px" }}>
                <span style={{ fontSize:"20px", color: i<=photoCount ? T.cyan : "#94A3B8" }}>
                  {i<=photoCount ? "📸" : "📷"}</span>
                <span style={{ fontSize:"9px", color: i<=photoCount ? T.cyan : "#94A3B8" }}>
                  {i<=photoCount ? "OK" : "+"}</span>
              </div>
            ))}
          </div>
        </div>

        <Input label={t("proof.serial_label")} name="serial"
          placeholder={t("proof.serial_placeholder")}
          value={proofSerialNumber}
          onChange={e => setSerial(e.target.value)} optional />

        <div style={{ marginBottom:"20px" }}>
          <label style={{ display:"block", fontSize:"13px", fontWeight:600,
            color:"#334155", marginBottom:"6px" }}>
            {t("proof.description_label")}
            <span style={{color:"#94A3B8", fontWeight:400}}> {t("proof.description_hint")}</span>
          </label>
          <textarea rows={4} placeholder={t("proof.description_placeholder")}
            value={proofDescription} onChange={e => setProofDesc(e.target.value)}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", fontFamily:"'DM Sans',sans-serif",
              resize:"none", outline:"none", boxSizing:"border-box",
              color:"#1E293B", background:"#fff" }} />
        </div>

        <Button variant="royal" full loading={loading}
          disabled={!proofDescription && !proofSerialNumber && photoCount === 0}
          onClick={submit}>
          {t("proof.submit_btn")}
        </Button>
      </div>
      <BottomNav />
    </div>
  );
}